import React from "react";
import { Chart } from "primereact/chart";

const WeeklyAverage = React.memo(function WeeklyAverage(props) {
  const weekdayWeekendData = {
    labels: ["Weekday", "Weekend"],
    datasets: [
      {
        label: "",
        data: [0.67, 0.6],
        backgroundColor: "#FF9800",
        participant: [32, 32],
      },
    ],
  };
  const weekdayWeekendOptions = {
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 10, // Ensures a difference of 10 units between y-axis ticks
        },
      },
    },
  };
  return (
    <div className="col-12">
      <strong className="fs-14 float-start">
        # OF USES PER DAY OF WEEK - WEEKDAY VS. WEEKEND DAILY AVERAGE
      </strong>
      <Chart
        type="bar"
        data={weekdayWeekendData}
        options={weekdayWeekendOptions}
      />
      <div className="my-table data-table">
        <div className="table-responsive">
          <table className="table text-start">
            <thead>
              <tr className="table-first-row-border">
                <th></th>
                {weekdayWeekendData.labels.map((label) => (
                  <th key={label} style={{ color: "#B1B1B1" }}>
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong style={{ color: "#949494" }}>AVERAGE</strong>
                </td>
                {weekdayWeekendData.datasets[0].data.map((data, index) => (
                  <td key={index} style={{ color: "#949494" }}>
                    {data}
                  </td>
                ))}
              </tr>
              <tr>
                <td>
                  <strong style={{ color: "#949494" }}>
                    # of Participants
                  </strong>
                </td>
                {weekdayWeekendData.labels.map((_, index) => (
                  <td key={index} style={{ color: "#949494" }}>
                    57
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

export default WeeklyAverage;
